/**
 * Drawer con la explicación tras una opción incorrecta en prácticas de
 * conversación. Wrapper sobre el componente compartido WrongExplanationDrawer
 * (mismo molecule que usan las activities de stories) para conservar los labels
 * propios del flujo de conversación. Mantengo el archivo para no romper
 * callsites previos.
 */

import { WrongExplanationDrawer } from '@/components/molecules/WrongExplanationDrawer';

export interface ConversationWrongExplanationDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  explanation: string | null;
}

export function ConversationWrongExplanationDrawer(
  props: ConversationWrongExplanationDrawerProps
) {
  // El componente compartido cae por defecto en los labels de conversación
  // (`conversation.explanationDrawerTitle` / `conversation.closeExplanation`),
  // así que no hace falta override.
  return <WrongExplanationDrawer {...props} />;
}
